import { Buffer } from "buffer";
import { initRuntimeConfig } from "../runtimeConfigClient";

import packageJson from '../package.json'


console.group('%c📦 Application Info', 'color: #03a9f4; font-weight: bold;');

console.info(
  `%cApp Name: %cE-Menu`,
  'color: gray; font-weight: bold;',
  'color: #00bcd4; font-weight: bold;'
);

console.info(
  `%cVersion: %c${packageJson.version}`,
  'color: gray; font-weight: bold;',
  'color: #4caf50; font-weight: bold;'
);

console.groupEnd();


window.Buffer = Buffer;

async function bootstrap() {
  // console.log("[main] Initializing runtime config...");
  await initRuntimeConfig();
  // console.log("[main] ✅ Runtime config ready, launching app...");
  await import("./index");
}

bootstrap();
